import { useState, useCallback } from "react";
import { ImagePlus, Image as ImageIcon, Video, Maximize2, LayoutDashboard } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import LoginPromptModal from "@/components/LoginPromptModal";

const bottomNavLinks = [
  { 
    label: "Gallery", 
    href: "/gallery", 
    icon: ImagePlus,
    protected: false,
  },
  { 
    label: "Generator", 
    href: "/generator", 
    icon: ImageIcon,
    protected: true,
  },
  { 
    label: "Video", 
    href: "/video-generator", 
    icon: Video,
    protected: true,
  },
  { 
    label: "Upscale", 
    href: "/video-upscale", 
    icon: Maximize2,
    protected: true,
  },
  { 
    label: "Dashboard", 
    href: "/dashboard", 
    icon: LayoutDashboard,
    protected: true,
  },
];

export const BottomNavBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { user } = useAuth();
  const [isLoginPromptOpen, setIsLoginPromptOpen] = useState(false);
  const [loginRedirect, setLoginRedirect] = useState<{ path: string } | null>(null);

  const handleNavClick = useCallback((e: React.MouseEvent, link: typeof bottomNavLinks[0]) => {
    if (link.protected && !user) {
      e.preventDefault();
      setLoginRedirect({ path: link.href });
      setIsLoginPromptOpen(true);
    }
  }, [user]);

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden glass-premium border-t" style={{ borderColor: "hsl(var(--gold))" }}>
        <div className="flex items-center justify-around h-16 px-2">
          {bottomNavLinks.map((link) => {
            const Icon = link.icon;
            const isActive = currentPath === link.href;
            
            return (
              <Link
                key={link.href}
                to={link.href}
                onClick={(e) => handleNavClick(e, link)}
                className="flex flex-col items-center justify-center gap-1 py-2 px-3 rounded-lg transition-all duration-200 hover:bg-background/10 relative"
              >
                {isActive && (
                  <div 
                    className="absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-8 rounded-full"
                    style={{ backgroundColor: "hsl(var(--gold))" }}
                  />
                )}
                <Icon 
                  className="h-6 w-6" 
                  style={{ color: isActive ? "hsl(var(--gold))" : "hsl(var(--foreground))" }}
                />
                <span 
                  className="text-[10px] font-medium"
                  style={{ color: isActive ? "hsl(var(--gold))" : "hsl(var(--muted-foreground))" }}
                >
                  {link.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>

      <LoginPromptModal
        isOpen={isLoginPromptOpen}
        onClose={() => setIsLoginPromptOpen(false)}
        redirectPath={loginRedirect?.path}
      />
    </>
  );
};
